import { render, staticRenderFns } from "./PreviewModalVideo.vue?vue&type=template&id=cc9d0018&scoped=true"
import script from "./PreviewModalVideo.vue?vue&type=script&lang=js"
export * from "./PreviewModalVideo.vue?vue&type=script&lang=js"
import style0 from "./PreviewModalVideo.vue?vue&type=style&index=0&id=cc9d0018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9d0018",
  null
  
)

export default component.exports